import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { VehicleTyreDefaultResource, VehicleTyreDefaults } from '@data/vehicles/vehicles.model';

@Component({
  selector: 'app-vehicle-tyre-defaults-producer',
  templateUrl: './vehicle-tyre-defaults-producer.component.html',
  styleUrls: ['./vehicle-tyre-defaults-producer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleTyreDefaultsProducerComponent {
  producer: string;
  @Input() set tyreDefaults(value: VehicleTyreDefaultResource[]) {
    this.producer = new VehicleTyreDefaults(value).getProducer();
  }
}
